import React from 'react';
import { EventCalendarDay } from './EventCalendarDay';
import styles from './EventCalendarWeek.module.scss';
export const EventCalendarWeek = ({ week, selection, dayEventPropsMap, isSelectable, onSelect, monthlySummary, }) => {
    return (<div className={styles.eventCalendarWeek} data-testid='calendar-week'>
      {week.map((day) => (<EventCalendarDay key={`${day.dateTime.toISO()}-${day.dayPosition}-day`} day={day} selection={selection} dayEventPropsMap={dayEventPropsMap} isSelectable={isSelectable} onSelect={onSelect} monthlySummary={monthlySummary}/>))}
    </div>);
};
